export default __webpack_public_path__ + "img/b0f68578adb6989d057293df944bb7f2.svg";